import React from 'react';
import './ProgressBar.css';

interface ProgressBarProps {
  progress: number; // 0-100
  height?: number;
  showLabel?: boolean;
  color?: string;
}

const ProgressBar: React.FC<ProgressBarProps> = ({
  progress,
  height = 8,
  showLabel = true,
  color
}) => {
  // Clamp progress between 0 and 100
  const clampedProgress = Math.min(Math.max(progress, 0), 100);
  
  // Determine color based on progress if not provided
  const getProgressColor = () => {
    if (color) return color;
    if (clampedProgress <= 33) return '#ef4444'; // red
    if (clampedProgress <= 66) return '#f59e0b'; // yellow
    return '#10b981'; // green
  };

  return (
    <div className="progress-bar-container">
      <div 
        className="progress-bar-track" 
        style={{ height: `${height}px` }}
      >
        <div
          className="progress-bar-fill"
          style={{
            width: `${clampedProgress}%`,
            backgroundColor: getProgressColor(),
            height: `${height}px`
          }}
        />
      </div>
      {showLabel && (
        <span className="progress-bar-label">
          {Math.round(clampedProgress)}%
        </span>
      )}
    </div>
  );
};

export default ProgressBar;
